import axios from '@/plugins/axios';
import { apiId, createCommandTransport } from '@/utils/ap/commands';

const transitions = new Set(['submit', 'release', 'declare-processing', 'hold', 'resume', 'cancel', 'link-payment']);

export function createAPPaymentService(client = axios, keyFactory) {
    const commands = createCommandTransport(client, keyFactory);
    const read = (url, params = {}, cancelToken) => client.get(url, { params, cancelToken }).then(response => response.data);
    const requestBase = '/api/provider-payment-requests/';
    return {
        commands,
        cancelSource:()=>client.CancelToken.source(),
        authorization: (id, cancelToken) => read(`/api/providerinvoices/${apiId(id)}/payment-authorization/`, {}, cancelToken),
        bankAccounts:(id,params,cancelToken)=>read(`/api/billingaccounts/${apiId(id)}/bankaccounts/`,{limit:50,offset:0,...params},cancelToken),
        schedule:(id,cancelToken)=>read(`/api/invoices/${apiId(id)}/payment-schedule/`,{},cancelToken),
        requests: (params, cancelToken) => read(requestBase, { limit: 50, ...params }, cancelToken),
        request: (id, cancelToken) => read(`${requestBase}${apiId(id)}/`, {}, cancelToken),
        authorize: (id, payload, identity) => commands.execute({ identity, url: `/api/providerinvoices/${apiId(id)}/payment-authorizations/`, payload }),
        revoke: (id, payload, identity) => commands.execute({ identity, url: `/api/provider-payment-authorizations/${apiId(id)}/revoke/`, payload }),
        create: (payload, identity) => commands.execute({ identity, url: requestBase, payload }),
        update: (id, payload, identity) => commands.execute({ identity, url: `${requestBase}${apiId(id)}/`, method: 'patch', payload }),
        transition(id, action, payload, identity) {
            if (!transitions.has(action)) throw new Error('Unknown payment transition.');
            return commands.execute({ identity, url: `${requestBase}${apiId(id)}/${action}/`, payload });
        },
    };
}

export default createAPPaymentService();
